/** FAQ, Support, and Advertising page copy (Danish). */
export const pagesMessagesDa = {
  faq: {
    pageTitle: "Ofte stillede spørgsmål",
    pageSubtitle: "Find svar på almindelige spørgsmål om WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Svar på almindelige spørgsmål om WasOK, scanning af produkter, privatliv og bedømmelser.",
    items: [
      {
        question: "Hvordan virker WasOK?",
        answer:
          "WasOK hjælper dig med at huske, hvilke produkter du kunne lide eller ikke kunne lide, ved at scanne stregkoder og gemme dine bedømmelser og noter. Scan blot et produkts stregkode, bedøm det, tilføj noter, og næste gang du scanner det samme produkt, ser du straks din tidligere anmeldelse.",
      },
      {
        question: "Gemmes mine data i skyen?",
        answer:
          "Nej! Alle dine data gemmes lokalt på din enhed. Vi synkroniserer ikke dine oplysninger til skyen, hvilket betyder, at din indkøbshistorik og produktmeninger forbliver helt private. Dette betyder dog også, at du bør tage backup af din enhed, hvis du vil bevare dine data.",
      },
      {
        question: "Skal jeg bruge internetforbindelse for at bruge WasOK?",
        answer:
          "Nej, WasOK fungerer helt offline. Da alle dine data gemmes lokalt på din enhed, kan du scanne produkter, tilføje bedømmelser og se din historik uden nogen internetforbindelse.",
      },
      {
        question: "Kan jeg bruge WasOK til enhver type produkt?",
        answer:
          "Ja! WasOK fungerer med ethvert produkt, der har en stregkode. Uanset om det er mad, kosmetik, husholdningsartikler, elektronik eller noget andet med en stregkode, kan du scanne det og gemme dine meninger.",
      },
      {
        question: "Hvordan scanner jeg en stregkode?",
        answer:
          "Åbn blot WasOK-appen, og tryk på scan-knappen. Ret dit kamera mod produktets stregkode, og appen registrerer og scanner den automatisk. Sørg for, at stregkoden er godt oplyst og i fokus for de bedste resultater.",
      },
      {
        question: "Kan jeg tilføje fotos til mine produktanmeldelser?",
        answer:
          "Ja! Du kan vedhæfte fotos til enhver produktanmeldelse. Dette er især nyttigt til at huske emballagedetaljer, ingredienslister eller andre visuelle oplysninger, der kan hjælpe dig med at huske, hvorfor du kunne lide eller ikke kunne lide et produkt.",
      },
      {
        question: "Hvilke oplysninger kan jeg gemme om produkter?",
        answer:
          "Du kan gemme bedømmelser (1-5 stjerner), tekstnoter, fotos, den pris du betalte, hvor du købte det, og brugerdefinerede kategorier. Disse omfattende oplysninger hjælper dig med at træffe informerede beslutninger, når du handler.",
      },
      {
        question: "Kan jeg oprette indkøbslister?",
        answer:
          "Ja! WasOK giver dig mulighed for at oprette indkøbslister ud fra produkter, du allerede har anmeldt. Dette gør det nemt at huske, hvilke produkter du elskede og vil købe igen.",
      },
      {
        question: "Hvordan organiserer jeg mine produkter?",
        answer:
          "Du kan organisere produkter ved hjælp af brugerdefinerede kategorier. Du kan for eksempel oprette kategorier som 'Snacks', 'Kaffe', 'Hudpleje' eller 'Rengøringsprodukter'. Dette gør det nemt at gennemse dine anmeldelser efter type.",
      },
      {
        question: "Er WasOK gratis at bruge?",
        answer:
          "Ja, WasOK er helt gratis at downloade og bruge. Der er ingen køb i appen, abonnementer eller skjulte gebyrer. Vi mener, at alle bør have adgang til en privat måde at huske deres produktpræferencer på.",
      },
      {
        question: "Er WasOK tilgængelig?",
        answer:
          "WasOK er designet til at kunne bruges af så mange mennesker som muligt. Appen indeholder tilgængelighedsfunktioner som understøttelse af skærmlæser, skalerbar tekst og en valgfri højkontrasttilstand.",
      },
      {
        question: "Hvad sker der, hvis jeg afinstallerer appen?",
        answer:
          "Da alle data gemmes lokalt på din enhed, vil afinstallation af appen slette alle dine produktanmeldelser, noter og indkøbslister. Sørg for at eksportere dine data, hvis du vil beholde en backup, før du afinstallerer.",
      },
      {
        question: "Kan jeg eksportere mine data?",
        answer:
          "Ja, WasOK giver dig mulighed for at eksportere dine data til backup-formål. Du kan eksportere alle dine anmeldelser til en fil, som du kan gemme på din enhed eller den cloud-lagring, du foretrækker.",
      },
      {
        question: "Sporer WasOK min placering?",
        answer:
          "Nej, WasOK sporer ikke din placering. Selvom du manuelt kan indtaste navnet på den butik, hvor du købte et produkt, bruger appen ikke GPS eller lokationstjenester.",
      },
      {
        question: "Kan jeg bruge WasOK på flere enheder?",
        answer:
          "I øjeblikket synkroniserer WasOK ikke mellem enheder, da alle data gemmes lokalt. Hver enhed vil have sin egen separate database over produkter og anmeldelser.",
      },
      {
        question: "Hvad hvis en stregkode ikke scanner?",
        answer:
          "Hvis en stregkode ikke scanner, skal du sikre dig, at den er godt oplyst og i fokus. Du kan også prøve at rengøre kameralinsen. Hvis stregkoden er beskadiget eller uklar, kan du muligvis indtaste stregkodenummeret manuelt.",
      },
    ],
    cta: {
      heading: "Har du stadig spørgsmål?",
      body: "Kontakt vores supportteam — vi hjælper gerne.",
      button: "Kontakt support",
    },
  },
  support: {
    pageTitle: "Support",
    seoTitle: "Support — WasOK",
    seoDescription:
      "Få hjælp til WasOK: kontakt support, rapporter fejl, og del feedback.",
    getHelp: {
      title: "Få hjælp",
      body: "Vi er her for at hjælpe dig med at få mest muligt ud af WasOK. Hvis du oplever problemer eller har spørgsmål, har vi flere ressourcer til rådighed til at hjælpe dig.",
    },
    faq: {
      title: "Ofte stillede spørgsmål",
      body: "Før du kontakter os, kan du tjekke vores FAQ-sektion, hvor vi besvarer de mest almindelige spørgsmål om WasOK. Du finder detaljerede oplysninger om, hvordan appen fungerer, privatliv, datalagring og mere.",
    },
    contact: {
      title: "Kontakt support",
      body: "Hvis du ikke kan finde det svar, du leder efter, er vores supportteam klar til at hjælpe. Du kan kontakte os på:",
      emailLabel: "E-mail:",
      responseTime: "Vi svarer normalt inden for 24-48 timer",
    },
    bugs: {
      title: "Rapportering af fejl",
      body: "Fundet en fejl? Vi sætter pris på din hjælp til at gøre WasOK bedre. Når du rapporterer en fejl, bedes du inkludere:",
      items: [
        "En detaljeret beskrivelse af problemet",
        "Trin til at genskabe problemet",
        "Din enhedsmodel og Android-version",
        "Screenshots eller skærmoptagelser, hvis muligt",
      ],
      sendPrefix: "Send fejlrapporter til:",
    },
    featureRequests: {
      title: "Funktionsanmodninger",
      bodyBefore:
        "Har du en idé til en ny funktion? Vi vil meget gerne høre fra dig! Send dine forslag til",
      bodyAfter:
        ". Selvom vi ikke kan implementere alle anmodninger, overvejer vi omhyggeligt al feedback, når vi planlægger fremtidige opdateringer.",
    },
    knownIssues: {
      title: "Kendte problemer",
      body: "Vi er i øjeblikket opmærksomme på følgende problemer og arbejder på løsninger:",
      items: [
        "Nogle stregkoder scanner muligvis ikke i svag belysning — prøv at bruge en lommelygte",
        "Meget lange produktnoter kan tage et øjeblik at gemme på ældre enheder",
        "Billedminiaturer kan fremstå pixelerede på skærme med høj opløsning",
      ],
    },
    appUpdates: {
      title: "App-opdateringer",
      body: "Vi udgiver regelmæssigt opdateringer med nye funktioner, forbedringer og fejlrettelser. Sørg for at holde WasOK opdateret via Google Play Store for at få de nyeste forbedringer.",
    },
    community: {
      title: "Fællesskab",
      body: "Bliv en del af vores fællesskab af brugere, der træffer smartere indkøbsbeslutninger med WasOK. Del tips, stil spørgsmål, og få kontakt med andre brugere på vores sociale kanaler.",
    },
    emergency: {
      title: "Akut support",
      body: 'Hvis du oplever et kritisk problem, der forhindrer dig i at bruge appen, bedes du markere din e-mail som "URGENT" i emnefeltet, så vi kan prioritere din anmodning.',
    },
    cta: {
      heading: "Har du stadig brug for hjælp?",
      body: "Vores supportteam er her for dig. Tøv ikke med at kontakte os med spørgsmål eller bekymringer.",
      button: "E-mail support",
    },
  },
  advertising: {
    pageTitle: "Reklamer & monetisering",
    seoTitle: "Reklamer — WasOK",
    seoDescription: "Hvordan WasOK griber reklamer og monetisering an.",
    approach: {
      title: "Vores tilgang",
      body: "Hos WasOK mener vi, at dine indkøbsvaner og produktmeninger er private og personlige. Vores forretningsmodel afspejler denne kerneværdi.",
    },
    noAds: {
      title: "Ingen reklamer",
      body: "WasOK viser ikke nogen reklamer. Vi vil aldrig vise dig annoncer baseret på de produkter, du scanner, de bedømmelser, du giver, eller andre data, du opretter i appen. Din oplevelse med WasOK er helt reklamefri.",
    },
    noDataSelling: {
      title: "Intet salg af data",
      body: "Vi sælger, udlejer eller deler ikke dine data med annoncører, datamæglere eller andre tredjeparter. Da alle dine data gemmes lokalt på din enhed, har vi end ikke adgang til dem. Dine produktanmeldelser, indkøbslister og noter tilhører kun dig.",
    },
    noTracking: {
      title: "Ingen sporing",
      body: "WasOK bruger ikke sporingspixels, analysetjenester eller anden teknologi, der overvåger din adfærd eller deler oplysninger med tredjeparter. Vi sporer ikke, hvilke produkter du scanner, hvilke butikker du handler i, eller hvordan du bruger appen.",
    },
    sustainability: {
      title: "Sådan holder vi det bæredygtigt",
      body: "Du undrer dig måske over, hvordan vi holder WasOK gratis uden annoncer eller salg af data. Vores tilgang er enkel:",
      items: [
        {
          label: "Gratis og åben:",
          text: "WasOK er gratis for alle at bruge, uden premium-niveauer eller betalingsspærringer",
        },
        {
          label: "Slank drift:",
          text: "Vi holder vores omkostninger lave ved at bygge effektiv, privatlivsfokuseret software",
        },
        {
          label: "Valgfrie donationer:",
          text: "Brugere, der elsker WasOK, kan støtte os gennem frivillige donationer",
        },
        {
          label: "Open source:",
          text: "Vi kan tilbyde konsulentbistand eller skræddersyet udvikling til organisationer",
        },
      ],
    },
    noAffiliate: {
      title: "Ingen affiliate-links",
      body: "WasOK bruger ikke affiliate-links eller modtager provision fra forhandlere. Når du scanner et produkt, omdirigerer vi dig ikke til at købe det nogen steder. Appen er udelukkende til din personlige registrering og beslutningstagning.",
    },
    noPromotions: {
      title: "Ingen produktpromoveringer",
      body: "Vi accepterer ikke betaling fra mærker eller producenter for at promovere deres produkter. WasOK vil aldrig foreslå produkter, fremhæve bestemte mærker eller påvirke dine bedømmelser på nogen måde. Dine meninger er dine egne.",
    },
    partnerships: {
      title: "Tredjepartssamarbejder",
      body: "WasOK samarbejder ikke med markedsføringsvirksomheder, dataaggregatorer eller reklamenetværk. Vi opererer uafhængigt og prioriterer dit privatliv over alt andet.",
    },
    future: {
      title: "Fremtidsplaner",
      body: "Vi er forpligtet til at holde WasOK reklamefri og privatlivsfokuseret. Hvis vi nogensinde har brug for at indføre en bæredygtig forretningsmodel i fremtiden, vil vi:",
      items: [
        "Annoncere eventuelle ændringer i god tid",
        "Aldrig gå på kompromis med privatliv eller datasikkerhed",
        "Altid tilbyde en måde at bruge appen uden sporing eller reklamer",
        "Lytte til brugerfeedback og bekymringer",
      ],
    },
    supporting: {
      title: "Støt WasOK",
      body: "Hvis du elsker WasOK og vil støtte vores mission om privatlivsfokuseret indkøbshukommelse, kan du:",
      items: [
        "Fortælle dine venner og familie om appen",
        "Efterlade en positiv anmeldelse på Google Play Store",
        "Dele din feedback og dine forslag med os",
        "Overveje at give en frivillig donation (når tilgængelig)",
      ],
    },
    cta: {
      heading: "Spørgsmål om vores politikker?",
      body: "Vi er transparente om, hvordan WasOK fungerer. Hvis du har spørgsmål om vores tilgang til privatliv, monetisering eller bæredygtighed, er du velkommen til at kontakte os.",
      button: "Kontakt os",
    },
  },
};
